// src/components/ProtectedRoute.jsx
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const ProtectedRoute = ({ children }) => {
  const { isAdmin } = useAuth();
  const location = useLocation();

  if (!isAdmin) {
    // Redirect to login page with return path
    return (
      <Navigate
        to="/login"
        state={{ from: location, adminRequired: true }}
        replace
      />
    );
  }

  return children;
};

export default ProtectedRoute;
